module.exports = __webpack_public_path__ + "media/images/icon-footer-arrow-29bdf1f0902349ffc6cd5f7beb7a0796.svg";